import gql from 'graphql-tag';

const MEDIA_FRAGMENT = gql`
	fragment media on Media {
		id
		link
		created
		isReviewed
		basket {
			id
		}
		creator {
			id
			firstname
			lastname
			destroyed
		}
		machine {
			id
			type
			assetId
			location {
				id
				name
			}
			place {
				id
				name
			}
			destroyed
			route {
				id
				name
			}
		}
		serviceDocket {
			id
			serviceRun {
				id
				name
				planned
				route {
					id
					name
				}
			}
		}
		route {
			id
			name
		}
		comment
	}
`;

export const CREATE_MEDIA = gql`
	mutation createMediaMutation($input: CreateMediaInput!) {
		createMedia(input: $input) {
			id
			link
			comment
			machine {
				id
				assetId
				type
				place {
					id
					name
				}
				location {
					id
					name
				}
			}
			serviceDocket {
				id
				status
				photoTaken
				machine {
					id
					type
					assetId
					place {
						id
						name
					}
					location {
						id
						name
					}
				}
			}
		}
	}
`;

export const GET_MEDIAS = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: MediaPageFilter
	) {
		getMedias(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...media
			}
			count
		}
	}
	${MEDIA_FRAGMENT}
`;


export const DESTROY_MEDIA = gql`
	mutation destroyMediaMutation ($id: ID!) {
		destroyMedia(id: $id)
	}
`;


export const GET_MEDIA = gql`
	query($id: String) {
		getMedia(id: $id) {
			...media
		}
	}
	${MEDIA_FRAGMENT}
`;

export const MODIFY_MEDIA = gql`
	mutation modifyMediaMutation($input: ModifyMediaInput!) {
		modifyMedia(input: $input) {
			media {
				...media
			}
		}
	}
	${MEDIA_FRAGMENT}
`;
